import { useEffect } from "react";

// Synthesized telephone ringtone via Web Audio (no asset needed).
export function useRingtone(active) {
  useEffect(() => {
    if (!active) return;
    let ctx;
    let interval;
    let stopped = false;
    try {
      const AC = window.AudioContext || window.webkitAudioContext;
      ctx = new AC();
    } catch {
      return;
    }

    const ring = () => {
      if (stopped || !ctx) return;
      const now = ctx.currentTime;
      // two short bursts = classic "ring ring"
      [0, 0.45].forEach((offset) => {
        const start = now + offset;
        const dur = 0.4;
        const gain = ctx.createGain();
        gain.connect(ctx.destination);
        gain.gain.setValueAtTime(0.0001, start);
        gain.gain.exponentialRampToValueAtTime(0.25, start + 0.04);
        gain.gain.exponentialRampToValueAtTime(0.0001, start + dur);
        [440, 480].forEach((freq) => {
          const osc = ctx.createOscillator();
          osc.type = "sine";
          osc.frequency.value = freq;
          osc.connect(gain);
          osc.start(start);
          osc.stop(start + dur);
        });
      });
    };

    ring();
    interval = setInterval(ring, 3000);
    return () => {
      stopped = true;
      clearInterval(interval);
      try { ctx.close(); } catch {}
    };
  }, [active]);
}
